import { type FC, useEffect } from 'react';

import { useHelpFetcherConnected, useHelpSlice } from '../../../../store';
import { HelpConnected, HelpFooter } from '../../../help';
import { NavPage } from '../page/NavPage';

export const NavPageHelpConnected: FC = () => {
  const helpFile = useHelpSlice.getHelpFile();
  const { fetchHelpFile } = useHelpFetcherConnected();

  useEffect(() => {
    if (!helpFile) {
      fetchHelpFile();
    }
  }, [fetchHelpFile, helpFile]);

  return (
    <NavPage footer={<HelpFooter />}>
      <HelpConnected inNavDrawer />
    </NavPage>
  );
};
